/* eslint-disable no-console */
import React from 'react';
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ApexBarChart from './bar-chart';
import ApexLineChart from './line-chart';
import ApexGroupLineChart from './line-chart_Group';

export default function Charts(props) {
  const { recovery_checked, data, product, Chartvalue, setChartValue, sliderRecoveryValue } = props;
  const ChartData = data?.as_bar_graph || [];
  const barChartData = ChartData[product] ? ChartData[product] : [];
  const lineChartData = data?.as_line_graph?.[product] || [];
  const lineChartRecoveryData = data?.recovery || 100;
  const handleChange = (event, newValue) => {
    setChartValue(newValue);
  };
  // console.log('lineChartData', lineChartData);
  // console.log('lineChartRecoveryData', Object.keys(lineChartData).filter((val) => val !== 'LSI/SDI'));
  const series_data=[];
  function calculateRatio(ipKsp, limit) {
    if (ipKsp.length !== limit.length || ipKsp.length === 0 || limit.length === 0) {
      console.error('IP/KSP and Limit array length should be same and greater than 0');
      return [];
    }

    const ratio = ipKsp.map((value, index) => {
      if (limit[index] !== 0) {
        return ((value * 100) / limit[index])>=120?120:value * 100 / limit[index];
      }
      return 0; // To handle division by zero if any limit value is zero
    });

    return ratio;
  }
  // Iterate over the keys of lineChartData, excluding 'LSI/SDI'
  Object.keys(lineChartData).filter((val) => val !== 'LSI/SDI').forEach((element) => {
    // If the element is 'CaCO3', push its data directly to series_data
    if (element === 'CaCO3') {
      series_data.push({
        'name': element,
        data: lineChartData?.[element]?.map(value => value > 120 ? 120 : value) || [],
      });
    } else if (lineChartData?.[element]?.['IP/KSP'].length !== 0) {
      // For other elements, calculate the ratio and push it to series_data
      series_data.push({
        'name': element,
        data: calculateRatio(lineChartData?.[element]?.['IP/KSP'] || [], lineChartData?.[element]?.Limit || []),
      });
    }
  });
  // console.log('barChartData', barChartData);
  // console.log('series_data', series_data);
  return (
    <TabContext value={Chartvalue}>
      <Box
        sx={{
          borderBottom: 1,
          width: '100%',
          borderColor: 'divider',
          maxWidth: { sm: '100%' },
          bgcolor: 'background.paper',
        }}
      >
        <TabList onChange={handleChange}
          variant="scrollable"
          scrollButtons
          aria-label="visible arrows tabs example"
        >
          <Tab label="Saturation" value="1" />
          <Tab label="Comparison" value="2" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="S&DI / LSI" value="3" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="CaSO4" value="4" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="BaSO4" value="5" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="SrSO4" value="6" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="CaF2" value="7" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="SiO2" value="8" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
          <Tab label="CaHPO4" value="9" disabled={!recovery_checked} style={{ 'display': !recovery_checked ? 'none' : 'block' }} />
        </TabList>
      </Box>
      <TabPanel value="1" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Saturation Indices</div>
        <ApexBarChart barChartData={series_data} Recoverychange={sliderRecoveryValue}/>
      </TabPanel>
      <TabPanel value="2" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Comparison of Saturation Index</div>
        <ApexGroupLineChart lineChartData={lineChartData || []}
          linevalue='Comparison of Saturation Index' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="3" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>S&DI/LSI</div>
        <ApexLineChart
          lineChartData={lineChartData ? lineChartData['LSI/SDI'] : []}
          linevalue='S&DI/LSI' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="4" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Calcium Sulfate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.CaSO4 : []} linevalue='CaSO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="5" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Barium Sulfate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.BaSO4 : []} linevalue='BaSO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="6" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Strontium Sulfate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.SrSO4 : []} linevalue='SrSO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="7" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Calcium Fluoride</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.CaF2 : []} linevalue='CaF2' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="8" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Silica</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.SiO2 : []} linevalue='SiO2' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
      <TabPanel value="9" >
        <div className="B_Bold" style={{
          'justifyContent': 'center',
          'display': 'flex'
        }}>Calcium Phosphate</div>
        <ApexLineChart lineChartData={lineChartData ? lineChartData.CaHPO4 : []} linevalue='CaHPO4' lineChartRecoveryData={lineChartRecoveryData} />
      </TabPanel>
    </TabContext>
  );
}
